import { checkMissingParams, fetchCCESExtensions } from './index';

export default async (params, signal) => {
  const paramsRules = {
    publisherId: { allowedTypes: ['string'] },
  };
  const requiredParams = ['publisherId'];
  checkMissingParams(params, requiredParams, paramsRules);

  const requestBody = {
    filters: {
      ownerIds: [params.publisherId],
    },
  };
  const response = await fetchCCESExtensions(signal, requestBody);
  return response?.items?.[0]?.owner ?? {};
};
